import React from 'react'
import PropTypes from "prop-types"
import { Modal, Form } from 'react-bootstrap'

import Button from '../../components/Button'
import MarkdownField from '../../lib/MarkdownField'

import {  getText } from '../../lib/text.js'

const NoteEditor = ({ item, onChange, onClose }) => (
  <Modal show onHide={() => onClose()}>
    <Modal.Header>
      <Modal.Title>
        Nota
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>

      <Form inline style={{marginTop: 15, marginBottom: 15}}>

        <MarkdownField
          label={getText("Nota para el cliente (para App)")}
          value={item.text || ""}
          onChange={x => onChange("text", x)}
        />

        <MarkdownField
          label={getText("Nota interna")}
          value={item.internalText || ""}
          onChange={x => onChange("internalText", x)}
        />

      </Form>

    </Modal.Body>
    <Modal.Footer>
      <Button glyph="ok" bsStyle="success" onClick={() => onClose()}> {getText("OK")} </Button>
    </Modal.Footer>
  </Modal>
)

NoteEditor.propTypes = {
  item: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default NoteEditor
